var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Profile',{key:_vm.$route.params.screenName || _vm.$route.params.profileId || 'myProfile'})}
var staticRenderFns = []

export { render, staticRenderFns }